import React,{useState,useEffect} from "react";
  import { useRouteMatch,Switch, Route } from "react-router-dom";

  import { useDispatch,useSelector } from 'react-redux';
import Profile from "../Dashboard/Profile/Profile";
import CRMLogin from "./CRMlogin";
  
import {  Link  } from "react-router-dom";
import { checkLeadManagerLoginStatus } from "../../store/actions/CRM/checkLeadManagerLoginStatus";
import Loading from "../Loading/Loading";
  
import { useHistory } from "react-router-dom/cjs/react-router-dom";

 const CRMDashboard = ({baseUrl})=>{
      const [open , setOpen]=useState(false);
   // const userdata = useSelector((state)=>state?.user?.user?.user);
   const dispatch = useDispatch();
    
         const history = useHistory();
   const [loader , setLoader] =useState({status:false});
   const [statusData , setStatusData] =useState({status:false});
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
   const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
 
    const {url,path} =useRouteMatch();
     
     
   const CRMtoken= useSelector((state)=>state?.crmData?.crmPass);
   
   const userdata = useSelector((state)=>state?.user?.user);
  useEffect(() => {
    setOpen(false) 
 setLoader({status:true});
 const LeadManagerLoginStatusData= {userEmail:userdata?.user_email,CRMtoken:CRMtoken,currentToken:currentToken}
    const user = dispatch(checkLeadManagerLoginStatus(LeadManagerLoginStatusData));
    /* get response as Promise   */
    user.then(response => {
    // pop up with message 
    //   console.log(response)
    setStatusData(response)

    if(response?.crmAccessStatus=='yes'){}else{ history.push(`${baseUrl}/crm-login`);}
   
     setInterval(()=>{
      // hide poped message 
      
     },3000)
     
 
  
  setLoader({status:false});
  
  
  
    }).catch(error => {
      
  /* resetting Login input Fields */
  //setLogin({user_email:'',user_pass:""
  
  // })
  setLoader({status:false});
      console.error(error);
    });
   



  }, []);
 
  


    return <>

{statusData?.crmAccessStatus=='yes'?
<div>
<div className="outer-right">
   <div className="outer-profile content-top">
<div className="outer-profile-in  " style={{background:"#fff",padding:"0px",marginTop:"5px",marginBottom:"5px"}}>
<div className="outer-profile-subvals outer-profile-title ">
<h3>  {"Hey "+(userdata?.first_name?userdata?.first_name:" There! ")+" Welcome to  classmock.com" }</h3></div>
    


        
</div>
<div  className=" outer-profile-in" style={{background:"#f1f1f1",padding:"0px",marginTop:"5px",marginBottom:"5px"}} >





   <div align="center" className="dashboardGridBtns">
    <Link  to={`${baseUrl}/new-lead`}>
<div >

<button   className="crm-button-one" type="submit" id="signupBtn">+New Lead</button>

</div></Link>

<Link to={`${baseUrl}/search`}>
<div  >

<button   className="crm-button-two" type="submit" id="signupBtn">Find A Lead</button>
 
</div> </Link>
   </div>
       
        
     </div>
     <div></div>
     </div>

       
       
            
                
                <div className="content-bottom">

        </div>
    </div>
</div>
:""}
   
    </>

}
export default CRMDashboard;
